
import React from "react";
import { CirclePlus } from "lucide-react";

interface AddButtonProps {
  onClick: (e: React.MouseEvent) => void;
}

export const AddButton: React.FC<AddButtonProps> = ({ onClick }) => {
  return (
    <button 
      className="absolute right-1 bottom-1 rounded-full hover:bg-primary/10 p-1 transition-colors group"
      onClick={onClick}
      title="Aggiungi evento"
    >
      <CirclePlus 
        className="h-5 w-5 text-primary/60 group-hover:text-primary transition-colors" 
      />
    </button>
  );
};
